var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 56,
    height: 56,
    fill: "#14077D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 14L38.4903 27.8197H53.0211L41.2654 36.3607L45.7557 50.1803L34 41.6393L22.2443 50.1803L26.7346 36.3607L14.9789 27.8197H29.5097L34 14Z",
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 28,
    height: 7,
    fill: "#14077D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 63,
    width: 28,
    height: 7,
    fill: "#14077D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 7,
    height: 28,
    fill: "#14077D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 21,
    width: 7,
    height: 28,
    fill: "#14077D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 14,
    height: 7,
    fill: "#14077D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 7,
    transform: "matrix(1 0 0 -1 7 63)",
    fill: "#14077D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 7,
    transform: "matrix(-1 0 0 1 63 7)",
    fill: "#14077D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 63,
    width: 14,
    height: 7,
    transform: "rotate(-180 63 63)",
    fill: "#14077D"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 7,
    height: 14,
    fill: "#14077D"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    transform: "matrix(1 0 0 -1 7 63)",
    fill: "#14077D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    transform: "matrix(-1 0 0 1 63 7)",
    fill: "#14077D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 63,
    width: 7,
    height: 14,
    transform: "rotate(-180 63 63)",
    fill: "#14077D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecIcon);
export default __webpack_public_path__ + "static/media/exec_icon.3acab5b289d9804339663b689d17949c.svg";
export { ForwardRef as ReactComponent };